import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const modifyGads = (dateFieldId, dateFieldLabelId, modifyAllId, textModifyAllId, modifyButtonId, closeSelector, gadId) => {
  const dateField = document.querySelector(dateFieldId);
  const dateFieldLabel = document.querySelector(dateFieldLabelId);
  const modifyAll = document.querySelector(modifyAllId);
  const textModifyAll = document.querySelector(textModifyAllId);
  const date = document.querySelector('.agenda_dateprev');
  const modifyButton = document.querySelector(modifyButtonId);
  const form = document.querySelector(`#form-guest-activity-${gadId}`);
  const closeButton = document.querySelector(closeSelector);

  const hiddenDateField = document.querySelector('#input_modifie_to');
  const hiddenActField = document.querySelector('#input_act');

  const magnifier = document.querySelector('#search-agenda-magnifier');

  dateField.value = date.value;

  modifyAll.onchange = (event) => {
    if (event.currentTarget.checked) {
      textModifyAll.style.display = 'block';
      dateField.disabled = true;
      dateFieldLabel.innerText = 'Dal';
      hiddenActField.value = 'modify_all';
    } else {
      textModifyAll.style.display = 'none';
      dateField.disabled = false;
      dateFieldLabel.innerText = 'Fino al';
      hiddenActField.value = '';
    }
  };

  modifyButton.onclick = () => {
    hiddenDateField.value = dateField.value;
    Loader.show();
    apiConnector()
      .post(`${form.action}.json`, new FormData(form))
      .then(() => {
        modifyAll.checked = false;
        textModifyAll.style.display = 'none';
        dateFieldLabel.innerText = 'Fino al';
        closeButton.click();
        Loader.hide();
        magnifier.click();
        hiddenActField.value = '';
        hiddenDateField.value = '';
      })
      .catch((err) => {
        console.log('qualcosa non ha funzionato', err);
        Loader.hide();
        errorManager(err);
      });
  };
};

const init = (dateFieldId, dateFieldLabelId, modifyAllId, textModifyAllId, modifyButtonId, closeSelector, gadId) => {
  try {
    modifyGads(dateFieldId, dateFieldLabelId, modifyAllId, textModifyAllId, modifyButtonId, closeSelector, gadId);
  } catch (e) {
    errorManager(e);
  }
};

window.ModifyAllGap = {
  init: init,
};
